import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/accounting/sales/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
    throw redirect({ to: '/accounting' })
  },
  component: () => null,
})
